import { CircularProgress, type SxProps } from '@mui/material';

interface Props {
  'aria-label'?: string;
  sx?: SxProps;
}

export const DropdownLoadingIcon = (props: Props) => {
  const { 'aria-label': ariaLabel, sx = {} } = props;

  return (
    <CircularProgress
      aria-label={ariaLabel}
      size={20}
      sx={{ mr: 2, color: 'inherit', ...sx }}
    />
  );
};
